import { z } from "zod";

// Server health for the instance administrator (#284): a small corner widget in the panel showing
// the production host's CPU, RAM and disk, so the platform admin sees load without an SSH session.
// Read-only, platform-admin only. The Hetzner VPS has no GPU (ADR-0020: GPU is the Mac detector's),
// so there is no GPU gauge here.

/** A used/total pair in bytes (RAM, disk). */
export const UsagePair = z.object({
  used: z.number().nonnegative(),
  total: z.number().positive(),
});
export type UsagePair = z.infer<typeof UsagePair>;

export const ServerMetricsDto = z.object({
  /** Whole-host CPU use since the previous sample, 0..1 (null on the first sample, no delta yet). */
  cpu: z.number().min(0).max(1).nullable(),
  /** 1-minute load average, and the host's CPU count to read it against. */
  load1: z.number().nonnegative(),
  cpuCount: z.number().int().positive(),
  memory: UsagePair,
  disk: UsagePair,
  /** Host uptime in seconds. */
  uptime: z.number().nonnegative(),
  /** When the sample was taken (server clock, ISO 8601). */
  at: z.string(),
});
export type ServerMetricsDto = z.infer<typeof ServerMetricsDto>;
